export const isBase64Image = (base64: string) => {
  return base64.includes('data:image');
};
